import { SHIPPING_METHODS_DATA } from '../actions/actionType'
const initialState = {
  shippingMethods: [],
}
export default function ShippingMethodsReducer(state = initialState, action) {
  switch (action.type) {
    case SHIPPING_METHODS_DATA:
      return { ...state, shippingMethods: action.payload }
    default:
      return state
  }
}
